module.exports = __webpack_public_path__ + "static/icon-upcoming-320px-11bbaec619fd81125a5561a915ac4ebe.png";